import { z } from 'zod';
/**
 * Kurzorova strankovani (09 §7): stabilni radeni (sort key + tiebreaker id),
 * kurzor = base64url JSON, klient nikdy nesazi offsety. Envelope = items +
 * nextCursor (null = posledni strana).
 */
export const DEFAULT_PAGE_LIMIT = 25;
export const MAX_PAGE_LIMIT = 100;
/** Dotaz na seznam - limit clampuje server, kurzor je opakni hodnota ze nextCursor. */
export const listQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(MAX_PAGE_LIMIT).default(DEFAULT_PAGE_LIMIT),
    cursor: z.string().max(512).optional(),
});
/** Obecna stranka seznamu nad polozkou `T`. */
export function pageSchema(item) {
    return z.object({
        items: z.array(item),
        nextCursor: z.nullable(z.string()),
    });
}
export function encodeCursor(payload) {
    return Buffer.from(JSON.stringify(payload), 'utf8').toString('base64url');
}
/** Vrati null pri jakemkoli poskozeni - kurzor NIKDY nevyhazuje chybu. */
export function decodeCursor(value) {
    try {
        const raw = JSON.parse(Buffer.from(value, 'base64url').toString('utf8'));
        if (typeof raw !== 'object' || raw === null)
            return null;
        const candidate = raw;
        if (typeof candidate['i'] !== 'string' || candidate['i'].length === 0)
            return null;
        if (candidate['c'] !== undefined && typeof candidate['c'] !== 'string')
            return null;
        return { i: candidate['i'], ...(candidate['c'] !== undefined ? { c: candidate['c'] } : {}) };
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=pagination.js.map